// Centralized copy constants for plan detail page
// Easy to revise and maintain consistency

export const PLAN_DETAIL_COPY = {
  // Provider row labels
  providerLabels: {
    provider: 'Provider',
    practice: 'Practice',
    state: 'State',
    market: 'Market',
    credentialStatus: 'Credential Status',
    acceptingPatients: 'Accepting Patients',
    ageRange: 'Age Range',
    editProviderStatus: (firstName: string, lastName: string) =>
      `Edit provider credential status for ${firstName} ${lastName}`,
  },

  // Market badge helper text (from @himanshu pant)
  marketBadge: {
    label: 'Market',
    helperText:
      'Market selection affects provider availability and credentialing status across all practices in this region.',
  },

  // Not found scenario
  notFound: {
    title: 'Plan Not Found',
    description:
      "This plan may have been deleted or you don't have access to view it.",
    goToPlansButton: 'Go to Plans',
    retryButton: 'Retry',
  },

  // Loading states
  loading: {
    headerSkeleton: 'Loading plan details...',
    providersSkeleton: 'Loading providers...',
  },

  // Toast messages
  toast: {
    saved: 'Changes saved successfully',
    error: 'Failed to save changes',
    retrySuccess: 'Data refreshed',
    retryError: 'Failed to refresh data',
  },

  // Delete flow
  delete: {
    title: 'Delete Plan',
    description:
      'Are you sure you want to delete this plan? This action cannot be undone.',
    confirmButton: 'Delete',
    cancelButton: 'Cancel',
  },

  // Accessibility
  a11y: {
    marketBadge: 'Current market selection',
    loadingSpinner: 'Loading data',
    providerRow: 'Provider information',
  },
} as const;

// Type for copy constants
export type PlanDetailCopy = typeof PLAN_DETAIL_COPY;
